﻿define([
	'jquery', 'pubsub', 'generalUtilities', 'moduleUtilities'],

function ($, pubsub, generalUtilities, moduleUtilities) {
	'use strict';

	//set up
	//-------------------------------------------

	var module, selectors, elements, values, $progressContainer;

	module = {};
	module.private = {};
	module.properties = {};

	selectors = {};
	selectors.countWrapper = '.js-agent-count-wrapper';
	selectors.countAgents = '.js-agent-count';

	elements = {};

	values = {};

	//utilities
	//-------------------------------------------

	module.private.getAgentCountData = function (data) {
		var displayData, presentAgents, totalAgents, currentAgents;

		totalAgents = data.response.Count;

		currentAgents = data.request.SkipCount || 0;
		currentAgents += data.response.Data.length;

		displayData = {
			presentAgents: currentAgents,
			totalAgents: totalAgents
		};

		return displayData;
	};

    module.private.determineAgentMessage = function (countData) {
        var isCommercial = generalUtilities.prop(window, 'RESAAS.Environment.Experience') === 'commercial';
		if (window.location.pathname.indexOf('brokeros') > -1) {
            return generalUtilities.stringFormat(RESAAS.Localization.UserSearch.USER_SEARCH_AGENT_COUNT, countData.presentAgents, countData.totalAgents.toLocaleString());
		}
		else {
            if (countData.totalAgents === 1) {
                if (isCommercial) {
                    return "1 broker found matching your search criteria.";
                } else {
                    return RESAAS.Localization.UserSearch.USER_SEARCH_SUMMARY_RESULT_TEXT_SINGLE;
                }
            } else {
                if (isCommercial) {
                    return generalUtilities.stringFormat("{0} brokers found matching your search criteria.", countData.totalAgents.toLocaleString());
                } else {
                    return generalUtilities.stringFormat(RESAAS.Localization.UserSearch.USER_SEARCH_SUMMARY_RESULT_TEXT, countData.totalAgents.toLocaleString());
                }
			}
		}
	}

	module.private.handleUserSearchBrowseSuccess = function (data) {
		var countData, hasAgents, $countWrapper, $agentCount, $countAgents, isEmptySearch, request;

		$countWrapper = $(selectors.countWrapper);
		$countAgents = $(selectors.countAgents);

		countData = module.private.getAgentCountData(data);
		isEmptySearch = true;
		request = data.request;

        if (request._subjectName || request._locationName || request.Name || request.Keywords || request.YearsOfExperience || request.LanguagesSpoken || request.RelationshipSearch) {
			isEmptySearch = false;
		}

		hasAgents = (countData.totalAgents !== 0);

		if (!hasAgents) {
			$countAgents.hide();
		} else {
			$countWrapper.html('<div class="re-agent-count js-agent-count"> </div>');
			$agentCount = $(selectors.countAgents);
			if (isEmptySearch) {
				$agentCount.text(" ");
			} else {
				$agentCount.text(module.private.determineAgentMessage(countData));
			}
		}
	};

	//event handlers
	//-------------------------------------------

	module.private.handleDataUserSearchBrowse = function (e, data) {
		if (moduleUtilities.isOwnEvent(data, module.properties)) {
			if (generalUtilities.prop(data,'response.Success')) {
				module.private.handleUserSearchBrowseSuccess(data);
			}
		}
	};

	module.private.init = function (e, data) {
		//set values
		module.properties.guid = (data && data.guid) ? data.guid : generalUtilities.uuid();
	}

	//external event bindings
	//-------------------------------------------

	pubsub.subscribe('uiAction.UserSearchResultSummaryControlInit', module.private.init);
	pubsub.subscribe('dataUserSearchBrowse', module.private.handleDataUserSearchBrowse);

	//expose API
	//-------------------------------------------
	return module;
}
);
